import React from "react";
import Layout from "../components/Layout";
import SalesDashboard from "../components/SalesDashboard/SalesDashboard";

const DashboardPage = () => {
  const userRole = localStorage.getItem("userRole");

  return (
    <Layout>
      <h1>
        {userRole === "admin" ? (
          "Admin Dashboard"
        ) : (
          <div>
            <SalesDashboard />
          </div>
        )}
      </h1>
    </Layout>
  );
};

export default DashboardPage;
